import { useQuery } from '@apollo/client/react';
import { SelfDocument } from '../graphql/types';

export const useHasHpcMembers = () => {
  const { data } = useQuery(SelfDocument);

  return Boolean(data?.self?.coachData?.hasHpcMembers);
};
